module.exports = __webpack_public_path__ + "static/img/51生活用纸.368835f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/51生活用纸.jpg
// module id = 0PHL
// module chunks = 0